/* wn-pdp: product page behaviour (gallery, variants, lenses + Rx, upgrades, add to cart, sticky bar,
   3-for-2 quick add, share, countdown, lazy videos, lightbox). Cart contract: POST /cart/add.js then
   dispatch `wn:cart:refresh` {open:true}. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var root = (window.WN && window.WN.root) || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduce = false; try { reduce = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var pad = function (n) { return String(n).padStart(2, '0'); };
  var q2 = function (n) { return (n > 0 ? '+' : '') + n.toFixed(2); };
  var clean = function (v) { return String(v || '').replace(/\s*[-–]\s*low stock/i, '').split(' - ')[0].replace(/\s*\(new\)/i, '').trim(); };
  var isLow = function (t) { return /low stock/i.test(t || ''); };
  /* whole dollars stay whole ($54), real cents show ($24.50) */
  function fmt(c) {
    c = Math.round(c || 0);
    var d = Math.floor(c / 100), r = c % 100;
    return '$' + String(d).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (r ? '.' + pad(r) : '');
  }
  var toastT;
  function toast(msg) {
    if (window.WNCart && typeof window.WNCart.toast === 'function') { try { return window.WNCart.toast(msg); } catch (e) {} }
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('on'); clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove('on'); }, 2400);
  }

  /* ---------- cart contract ---------- */
  function addItems(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || j.message || 'Something went wrong. Try again.');
        document.dispatchEvent(new CustomEvent('wn:cart:refresh', { detail: { open: true } }));
        if (!(window.WNCart && typeof window.WNCart.refresh === 'function') && window.WNCart && window.WNCart.open) window.WNCart.open();
        return j;
      });
    });
  }
  window.WNPdp = { add: addItems, fmt: fmt };

  /* ---------- countdowns (live whisply.js modes) ---------- */
  function cdTarget(mode) {
    var now = Date.now(); mode = mode || 'week';
    if (mode.indexOf('rolling:') === 0) {
      var mins = parseFloat(mode.split(':')[1]) || 45, len = mins * 60000, key = 'w_cd_' + mins, start = 0;
      try { start = +localStorage.getItem(key) || 0; if (!start) { start = now; localStorage.setItem(key, start); } } catch (e) { start = now - (now % len); }
      return start + Math.ceil((now - start + 1) / len) * len;
    }
    if (mode.indexOf('date:') === 0) return new Date(mode.slice(5)).getTime();
    var d = new Date();
    if (mode === 'midnight') { d.setHours(24, 0, 0, 0); return d.getTime(); }
    d.setDate(d.getDate() + ((7 - d.getDay()) % 7)); d.setHours(24, 0, 0, 0); return d.getTime();
  }
  function tick() {
    $$('[data-wp-cd]').forEach(function (el) {
      var s = Math.max(0, Math.floor((cdTarget(el.dataset.wpCd) - Date.now()) / 1000));
      var D = Math.floor(s / 86400), H = Math.floor((s % 86400) / 3600), M = Math.floor((s % 3600) / 60), S = s % 60;
      el.textContent = D ? D + 'd ' + H + 'h ' + pad(M) + 'm' + (el.hasAttribute('data-wp-cd-short') ? '' : ' ' + pad(S) + 's') : H ? H + 'h ' + pad(M) + 'm ' + pad(S) + 's' : M + 'm ' + pad(S) + 's';
    });
  }

  /* ---------- lazy videos ---------- */
  function lazyVideos(scope) {
    var vids = $$('video[data-wp-lazyvid]', scope);
    if (!vids.length) return;
    var mob = matchMedia('(max-width: 749px)').matches;
    var load = function (v) {
      var h = v.dataset.wpVidM, src = (mob && /m3u8/.test(h) && v.canPlayType('application/vnd.apple.mpegurl')) ? h : v.dataset.wpVidD;
      v.removeAttribute('data-wp-lazyvid'); if (!src) return;
      v.src = src; if (!reduce) { var p = v.play(); p && p.catch && p.catch(function () {}); }
    };
    if (!('IntersectionObserver' in window)) return vids.forEach(load);
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); load(e.target); } });
    }, { rootMargin: '300px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- lightbox ---------- */
  var lb;
  document.addEventListener('click', function (e) {
    var z = e.target.closest('[data-wp-zoom]'); if (!z) return;
    if (!lb) {
      lb = document.createElement('div'); lb.className = 'lp-lb'; lb.hidden = true;
      lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Photo'); lb.tabIndex = -1;
      lb.innerHTML = '<img alt="">'; document.body.appendChild(lb);
      lb.addEventListener('click', function () { lb.hidden = true; z && z.focus && z.focus(); });
      document.addEventListener('keydown', function (k) { if (k.key === 'Escape' && !lb.hidden) lb.hidden = true; });
    }
    $('img', lb).src = z.dataset.wpZoom; lb.hidden = false; lb.focus();
  });

  /* ---------- Rx wizard (live whisply-rx behaviour). Uses window.WNRx.mount when a shared one exists. ---------- */
  function mountRx(rx, opts) {
    var fees = opts.fees, onChange = opts.onChange || function () {};
    var val = function (k) { var el = $('[data-rx="' + k + '"]', rx); return el ? String(el.value).trim() : ''; };
    $$('select[data-rx$="_sph"]', rx).forEach(function (s) {
      s.innerHTML = '<option value="">Select</option>';
      for (var n = 24; n >= -32; n--) { var o = document.createElement('option'); o.textContent = n === 0 ? '0.00' : q2(n / 4); s.appendChild(o); }
    });
    $$('select[data-rx$="_cyl"]', rx).forEach(function (s) {
      s.innerHTML = '<option value="">None</option>';
      for (var n = -1; n >= -24; n--) { var o = document.createElement('option'); o.textContent = (n / 4).toFixed(2); s.appendChild(o); }
    });
    var dual = $('[data-rx-dual]', rx);
    function fee() {
      var c = Math.min(parseFloat(val('od_cyl')) || 0, parseFloat(val('os_cyl')) || 0);
      return c <= -4.25 ? fees.large : c <= -2.25 ? fees.medium : fees.small;
    }
    function sync() {
      var f = fee(), key = f === fees.large ? 'large' : f === fees.medium ? 'medium' : 'small';
      $('[data-rx-tier]', rx).textContent = f.label;
      $('[data-rx-fee-price]', rx).textContent = '+' + fmt(f.price);
      $$('[data-rx-t]', rx).forEach(function (t) { t.classList.toggle('is-on', t.dataset.rxT === key); });
      var th = $('[data-rx-thumb]', rx); if (th) th.style.transform = 'translateX(' + ({ small: 0, medium: 1, large: 2 }[key] * 100) + '%)';
      $$('select[data-rx], input[data-rx]', rx).forEach(function (x) { x.classList.toggle('is-filled', !!x.value); if (x.value) x.classList.remove('is-invalid'); });
      var eyes = !!(val('od_sph') && val('os_sph'));
      var pd = dual && dual.checked ? !!(val('pd_r') && val('pd_l')) : !!val('pd');
      var ok = $('[data-rx-confirm]', rx).checked, done = [eyes, pd, ok], cur = done.indexOf(false);
      $$('[data-rx-step]', rx).forEach(function (s, i) { s.classList.toggle('is-done', done[i]); s.classList.toggle('is-on', i === cur || done[i]); });
      var p = $('[data-rx-progress]', rx); if (p) p.style.width = Math.max(8, (done.filter(Boolean).length / 3) * 100) + '%';
      onChange();
    }
    dual && dual.addEventListener('change', function () {
      $('[data-rx-pd2]', rx).hidden = !dual.checked;
      $('[data-rx="pd"]', rx).closest('label').style.opacity = dual.checked ? '.4' : '1';
    });
    rx.addEventListener('change', sync); rx.addEventListener('input', sync);
    sync();
    function validate() {
      var need = ['od_sph', 'os_sph'].concat(dual && dual.checked ? ['pd_r', 'pd_l'] : ['pd']), bad = null;
      need.forEach(function (k) { var el = $('[data-rx="' + k + '"]', rx); if (el && !el.value) { el.classList.add('is-invalid'); bad = bad || el; } });
      if (bad) { bad.focus(); return 'Please complete your prescription (SPH for both eyes and PD).'; }
      var eyes = ['od', 'os'];
      for (var i = 0; i < 2; i++) {
        var e = eyes[i], c = val(e + '_cyl'), a = val(e + '_axis');
        if ((c && !a) || (!c && a)) { var el = $('[data-rx="' + e + '_axis"]', rx); el.classList.add('is-invalid'); el.focus(); return (e === 'od' ? 'Right' : 'Left') + ' eye: CYL and AXIS go together.'; }
        if (a && (+a < 0 || +a > 180)) return 'AXIS must be between 0 and 180.';
      }
      if (!$('[data-rx-confirm]', rx).checked) return 'Please confirm your prescription is valid.';
      return null;
    }
    /* cart line properties for the frame + fee lines, linked by _Whisply RX Pair */
    function lines(variantId, qty, props) {
      var f = fee();
      var pd = dual && dual.checked ? 'R ' + val('pd_r') + ' / L ' + val('pd_l') : val('pd');
      var line = function (k) { return 'SPH ' + val(k + '_sph') + ' · CYL ' + (val(k + '_cyl') || 'None') + ' · AXIS ' + (val(k + '_axis') || '-'); };
      var pair = 'rxpair-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
      var p = Object.assign({}, props || {});
      p['Prescription'] = 'RX Size: ' + f.label + '\nRight Eye (OD): ' + line('od') + '\nLeft Eye (OS): ' + line('os') + '\nPD: ' + pd;
      p['_Whisply RX Pair'] = pair;
      return { pair: pair, items: [
        { id: variantId, quantity: qty, properties: p },
        { id: f.id, quantity: qty, properties: {
          '_Lab Cost': f.lab, '_Whisply RX Pair': pair,
          '_RX': 'OD:' + val('od_sph') + '/' + (val('od_cyl') || '0') + 'x' + (val('od_axis') || '000') + ' | OS:' + val('os_sph') + '/' + (val('os_cyl') || '0') + 'x' + (val('os_axis') || '000') + ' | PD:' + pd } }
      ] };
    }
    return { fee: fee, validate: validate, lines: lines };
  }

  /* ---------- product section ---------- */
  function initPdp(sec) {
    if (sec._wp) return; sec._wp = true;
    var data = JSON.parse($('[data-wp-variants]', sec).textContent);
    var form = $('[data-wp-form]', sec), vid = $('[data-wp-vid]', sec);
    var opts = $$('[data-wp-opt]', sec);
    var live = function (k) { return $$('[data-wp-live="' + k + '"]', sec); };
    var addBtn = $('[data-wp-add]', sec), addLabel = $('[data-wp-add-label]', sec);
    var labelBase = (addBtn && addBtn.dataset.label) || 'Add to bag';
    var err = $('[data-wp-err]', sec);
    var variant = data.variants.filter(function (v) { return String(v.id) === vid.value; })[0] || data.variants[0];
    var hideOthers = sec.hasAttribute('data-hide-others');

    /* gallery */
    var progEl = $('[data-wp-prog]', sec), track = $('[data-wp-track]', sec), thumbsBar = $('[data-wp-thumbs]', sec), dotsEl = $('[data-wp-dots]', sec);
    var prevB = $('[data-wp-nav="-1"]', sec), nextB = $('[data-wp-nav="1"]', sec);
    var slides = function () { return track ? $$('.lp-slide', track).filter(function (s) { return !s.hidden; }) : []; };
    var thumbFor = function (id) { return thumbsBar ? $('.wp-thumb[data-media-id="' + id + '"]', thumbsBar) : null; };
    var curIdx = 0;
    function paintActive() {
      var list = slides(), s = list[curIdx]; if (!s) return;
      if (thumbsBar) $$('.wp-thumb', thumbsBar).forEach(function (t) {
        var on = t.dataset.mediaId === s.dataset.mediaId;
        t.classList.toggle('is-on', on); if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        if (on && thumbsBar.scrollWidth > thumbsBar.clientWidth) thumbsBar.scrollTo({ left: t.offsetLeft - thumbsBar.clientWidth / 2 + t.clientWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
      });
      if (dotsEl) $$('i', dotsEl).forEach(function (d, i) { d.classList.toggle('on', i === Math.min(curIdx, 9)); });
      if (progEl) { var pi = $('i', progEl); progEl.hidden = list.length < 2; if (pi) { pi.style.width = (100 / Math.max(1, list.length)) + '%'; pi.style.transform = 'translateX(' + (curIdx * 100) + '%)'; } }
      if (prevB) prevB.disabled = curIdx <= 0;
      if (nextB) nextB.disabled = curIdx >= list.length - 1;
    }
    function buildDots() {
      if (!dotsEl) return;
      var n = Math.min(slides().length, 10);
      dotsEl.innerHTML = n > 1 ? new Array(n + 1).join('<i></i>') : '';
      dotsEl.hidden = n <= 1;
    }
    function goTo(i, smooth) {
      var list = slides(); if (!list.length || !track) return;
      i = Math.max(0, Math.min(list.length - 1, i)); curIdx = i;
      track.scrollTo({ left: list[i].offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' });
      paintActive();
    }
    if (track) {
      var raf = 0;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var w = track.clientWidth || 1, i = Math.round(track.scrollLeft / w);
          if (i !== curIdx) { curIdx = i; paintActive(); }
        });
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(curIdx + 1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(curIdx - 1, true); }
      });
      $$('.lp-slide img', track).forEach(function (img) {
        img.parentNode.addEventListener('click', function () {
          if (matchMedia('(max-width: 999px)').matches) return;
          var big = img.currentSrc || img.src; var z = document.createElement('span'); z.dataset.wpZoom = big.replace(/width=\d+/, 'width=2000');
          document.body.appendChild(z); z.click(); z.remove();
        });
      });
    }
    if (thumbsBar) thumbsBar.addEventListener('click', function (e) {
      var t = e.target.closest('.wp-thumb'); if (!t) return;
      var list = slides(); var i = list.findIndex(function (s) { return s.dataset.mediaId === t.dataset.mediaId; });
      if (i >= 0) goTo(i, true);
    });
    prevB && prevB.addEventListener('click', function () { goTo(curIdx - 1, true); });
    nextB && nextB.addEventListener('click', function () { goTo(curIdx + 1, true); });
    function showVariantMedia(mediaId) {
      if (!track || !mediaId) return;
      var slide = $('.lp-slide[data-media-id="' + mediaId + '"]', track); if (!slide) return;
      if (hideOthers) {
        $$('.lp-slide[data-variant-media]', track).forEach(function (s) { s.hidden = s.dataset.mediaId !== String(mediaId); });
        if (thumbsBar) $$('.wp-thumb', thumbsBar).forEach(function (t) {
          var s = $('.lp-slide[data-media-id="' + t.dataset.mediaId + '"]', track);
          if (s && s.hasAttribute('data-variant-media')) t.hidden = t.dataset.mediaId !== String(mediaId);
        });
        slide.hidden = false; track.prepend(slide);
        var th = thumbFor(mediaId); if (th) { th.hidden = false; thumbsBar.prepend(th); }
        buildDots(); goTo(0, false);
      } else {
        var i = slides().indexOf(slide); goTo(i, true);
      }
    }
    buildDots(); paintActive();

    /* variants */
    var selected = function () { return opts.map(function (f) { var b = $('[aria-pressed="true"]', f); return b ? b.dataset.value : null; }); };
    function markAvailability() {
      var sel = selected();
      opts.forEach(function (f, oi) {
        $$('button', f).forEach(function (b) {
          var test = sel.slice(); test[oi] = b.dataset.value;
          var m = data.variants.filter(function (v) { return v.options.every(function (o, i) { return o === test[i]; }); })[0];
          b.classList.toggle('is-out', !m || !m.available);
        });
      });
    }
    function update(v, fromUser) {
      if (!v) return;
      variant = v; vid.value = v.id; vid.dispatchEvent(new Event('change', { bubbles: true }));
      var save = v.compare > v.price ? v.compare - v.price : 0;
      live('price').forEach(function (e) { e.textContent = fmt(v.price); });
      live('was').forEach(function (e) { e.textContent = fmt(v.compare); e.hidden = !save; });
      live('pill').forEach(function (e) { e.textContent = 'You save ' + fmt(save); e.hidden = !save; });
      live('save').forEach(function (e) { e.textContent = 'Save ' + fmt(save); e.hidden = !save; });
      var cName = data.colorIndex >= 0 ? clean(v.options[data.colorIndex]) : '';
      var low = isLow(v.options.join(' '));
      live('color').forEach(function (e) { e.textContent = cName; });
      live('dot').forEach(function (e) { if (v.dot) e.style.background = v.dot; });
      live('low-label').forEach(function (e) { e.hidden = !low; });
      live('low').forEach(function (e) { e.hidden = !(low || data.lowListed); });
      live('sticky-sub').forEach(function (e) { if (cName) e.textContent = cName; });
      var st = !v.available ? 'out' : (low || data.lowListed) ? 'low' : 'in';
      live('stock').forEach(function (e) { e.dataset.state = st; });
      live('stock-t').forEach(function (e) { e.textContent = st === 'out' ? 'Sold out' : st === 'low' ? 'Low stock' : 'Available in stock'; });
      if (v.sku) live('code').forEach(function (e) { e.textContent = 'Code ' + v.sku; });
      opts.forEach(function (f, i) { var l = $('[data-wp-opt-label]', f); if (l) l.textContent = clean(v.options[i]); });
      refresh(); markAvailability();
      if (fromUser) {
        if (v.mediaId) showVariantMedia(v.mediaId);
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u);
      }
    }
    opts.forEach(function (f, oi) {
      f.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        $$('button', f).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        var sel = selected();
        var v = data.variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
        if (!v) {
          v = data.variants.filter(function (x) { return x.options[oi] === b.dataset.value && x.available; })[0] || data.variants.filter(function (x) { return x.options[oi] === b.dataset.value; })[0];
          if (v) opts.forEach(function (ff, i) { $$('button', ff).forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.value === v.options[i])); }); });
        }
        update(v, true);
      });
    });
    markAvailability();

    /* quantity */
    var qty = $('[data-wp-qty]', sec);
    var getQ = function () { return qty ? Math.max(1, Math.min(99, parseInt(qty.value, 10) || 1)) : 1; };
    $$('[data-wp-step]', sec).forEach(function (b) {
      b.addEventListener('click', function () { qty.value = Math.max(1, Math.min(99, getQ() + parseInt(b.dataset.wpStep, 10))); refresh(); });
    });
    qty && qty.addEventListener('input', refresh);

    /* upgrades */
    var ups = $$('[data-wp-upsell]', sec);
    ups.forEach(function (u) { u.addEventListener('change', refresh); });

    /* lenses + Rx */
    var rx = $('[data-wp-rx]', sec), rxMode = 'frame', rxApi = null;
    if (rx) {
      var fees = JSON.parse($('[data-wp-rx-fees]', rx).textContent);
      var panel = $('[data-rx-panel]', rx);
      var shared = window.WNRx && typeof window.WNRx.mount === 'function' ? window.WNRx.mount(panel, { fees: fees, onChange: function () { refresh(); } }) : null;
      rxApi = shared && typeof shared.fee === 'function' && typeof shared.validate === 'function' && typeof shared.lines === 'function' ? shared : mountRx(rx, { fees: fees, onChange: function () { refresh(); } });
      $$('[data-rx-mode]', rx).forEach(function (t) {
        t.addEventListener('click', function () {
          rxMode = t.dataset.rxMode;
          $$('[data-rx-mode]', rx).forEach(function (x) { x.setAttribute('aria-selected', String(x === t)); });
          panel.hidden = rxMode !== 'rx'; rx.classList.toggle('is-rx', rxMode === 'rx');
          syncWarranty(); refresh();
        });
      });
      if (new URLSearchParams(location.search).get('rx') === '1') {
        setTimeout(function () { var t = $('[data-rx-mode="rx"]', rx); t && t.click(); rx.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }, 400);
      }
    }
    function rxOn() { return !!(rx && rxMode === 'rx'); }
    var la = rx ? $('[data-rx-la]', rx) : null;
    function laOn() { return !!(la && la.checked); }
    if (la) la.addEventListener('change', function () { refresh(); });
    function syncWarranty() {
      ups.filter(function (u) { return u.hasAttribute('data-warranty') && u.dataset.rxId; }).forEach(function (u) {
        var row = u.closest('.lp-up'); if (!row) return;
        var nm = $('.lp-up__t b', row), pr = $('.lp-up__p', row), im = $('.lp-up__img img', row);
        if (!row.dataset.baseTitle) { row.dataset.baseTitle = nm ? nm.textContent : ''; row.dataset.baseImg = im ? (im.currentSrc || im.src) : ''; }
        var on = rxOn();
        if (nm) nm.textContent = on ? u.dataset.rxTitle : row.dataset.baseTitle;
        if (pr) pr.textContent = '+' + fmt(on ? +u.dataset.rxPrice : +u.dataset.price);
        if (im && u.dataset.rxImg) { im.removeAttribute('srcset'); im.src = on ? u.dataset.rxImg : row.dataset.baseImg; }
        row.classList.toggle('is-rx', on);
      });
    }
    /* second pair at 50% off (wn-product [data-lp-p2]): opt-in toggle, then colour + lenses; added with the main Add to bag.
       The store's automatic Buy 1 Get 1 50% discount prices it at checkout. Prescription reuses pair 1's Rx and lens lines. */
    var p2 = $('[data-lp-p2]', sec), p2On = p2 && $('[data-p2-on]', p2), p2Body = p2 && $('[data-p2-body]', p2);
    var p2Sw = p2 ? $$('.lp-p2__b', p2) : [], p2Ls = p2 ? $$('[data-p2-lens]', p2) : [], p2Msg = p2 && $('[data-p2-msg]', p2);
    var p2Pick = null, p2Manual = false, p2Lens = 'frame';
    function p2Active() { return !!(p2On && p2On.checked); }
    function p2Rx() { return !!(rx && p2Active() && p2Lens === 'rx'); }
    function p2Var() { return p2Pick ? { id: +p2Pick.dataset.id, price: +p2Pick.dataset.price, name: p2Pick.title } : { id: variant.id, price: variant.price, name: data.colorIndex >= 0 ? clean(variant.options[data.colorIndex]) : '' }; }
    function p2Off(v) { return Math.round(Math.min(v.price, variant.price) / 2); }
    function p2Fees() { return p2Rx() && rxOn() ? rxApi.fee().price + (laOn() ? parseInt(la.dataset.price, 10) : 0) : 0; }
    function p2Cost() { if (!p2Active()) return 0; var v = p2Var(); return v.price - p2Off(v) + p2Fees(); }
    function radio(list, el) { list.forEach(function (x) { x.setAttribute('aria-checked', String(x === el)); x.tabIndex = x === el ? 0 : -1; }); }
    function p2Select(b, manual) { if (!b) return; p2Pick = b; if (manual) p2Manual = true; radio(p2Sw, b); var n = $('[data-p2-name]', p2); if (n) n.textContent = b.title; refresh(); }
    function p2Default() { if (p2Manual || !p2Sw.length) return; p2Select(p2Sw.filter(function (x) { return x.dataset.id !== String(variant.id); })[0] || p2Sw[0]); }
    function p2Paint() {
      if (!p2) return;
      var on = p2Active(), v = p2Var(), f = p2Fees();
      p2.classList.toggle('is-on', on); p2Body.hidden = !on; p2On.setAttribute('aria-expanded', String(on));
      var was = $('[data-p2-was]', p2), now = $('[data-p2-now]', p2), fe = $('[data-p2-fee]', p2);
      if (was) was.textContent = fmt(v.price);
      if (now) now.textContent = fmt(v.price - p2Off(v));
      if (fe) { fe.textContent = f ? '+ ' + fmt(f) + ' lenses' : ''; fe.hidden = !f; }
      if (p2Msg) p2Msg.hidden = !(p2Rx() && !rxOn());
    }
    if (p2) {
      var lensRow = $('[data-p2-lens-row]', p2); if (lensRow && !rx) lensRow.remove();
      p2On.addEventListener('change', function () { if (p2Active()) p2Default(); refresh(); });
      p2Sw.forEach(function (b) { b.addEventListener('click', function () { p2Select(b, true); }); });
      p2Ls.forEach(function (b) { b.addEventListener('click', function () { p2Lens = b.dataset.p2Lens; radio(p2Ls, b); refresh(); }); });
      $$('[role="radiogroup"]', p2).forEach(function (g) {
        g.addEventListener('keydown', function (e) {
          var k = e.key, d = k === 'ArrowRight' || k === 'ArrowDown' ? 1 : k === 'ArrowLeft' || k === 'ArrowUp' ? -1 : 0; if (!d) return;
          var l = $$('[role="radio"]', g), i = l.indexOf(document.activeElement); if (i < 0) return;
          e.preventDefault(); var n = l[(i + d + l.length) % l.length]; n.focus(); n.click();
        });
      });
      var p2RxBtn = $('[data-p2-rx]', p2);
      if (p2RxBtn) p2RxBtn.addEventListener('click', function () { var t = $('[data-rx-mode="rx"]', rx); t && t.click(); });
      vid.addEventListener('change', function () { p2Default(); });
      p2Default();
    }
    /* button price: frame + lenses (Rx fee, light adaptive) + second pair. Add-on checkboxes (case, care, warranty) are
       left out here; their total shows next to the add-ons heading (paintUps) and they are still added to the bag. */
    function extras() {
      var t = 0;
      if (rxOn()) t += rxApi.fee().price * getQ();
      if (rxOn() && laOn()) t += parseInt(la.dataset.price, 10) * getQ();
      return t + p2Cost();
    }
    var upsBox = $('[data-wp-ups]', sec), sPrice = $('[data-wp-sticky-price]', sec), sAdd = $('[data-wp-sticky-add]', sec);
    function paintUps() {
      if (!upsBox) return;
      var on = ups.filter(function (u) { return u.checked; });
      var sum = on.reduce(function (a, u) { var w = u.hasAttribute('data-warranty'); return a + parseInt(w && rxOn() && u.dataset.rxPrice ? u.dataset.rxPrice : u.dataset.price, 10) * (w ? getQ() : 1); }, 0);
      var tot = $('[data-wp-ups-tot]', upsBox), note = $('[data-wp-ups-note]', upsBox);
      if (tot) { tot.hidden = !on.length; tot.textContent = '+' + fmt(sum); }
      if (note) note.textContent = on.length ? on.length + ' added' : '';
      upsBox.classList.toggle('has-on', !!on.length);
    }
    function refresh() {
      paintUps(); p2Paint();
      if (!addBtn || !addLabel) return;
      if (!variant.available) { addLabel.textContent = 'Sold out'; addBtn.disabled = true; if (sAdd) sAdd.textContent = 'Sold out'; return; }
      addBtn.disabled = false;
      var total = fmt(variant.price * getQ() + extras());
      addLabel.textContent = (rxOn() ? 'Add with prescription' : labelBase) + ' · ' + total;
      if (sPrice) sPrice.textContent = total;
      if (sAdd) sAdd.textContent = rxOn() ? 'Add with prescription' : (sAdd.dataset.label || labelBase);
    }
    function showErr(m) { if (!err) { if (m) alert(m); return; } err.textContent = m || ''; err.hidden = !m; }

    /* label each Rx lens line with the frame + colour it is for, so the order shows which pair gets which prescription */
    function lensFor(list, pair, colour) {
      var label = data.title + (colour ? ' · ' + colour : '');
      list.forEach(function (it) { var pr = it.properties || {}; if (pr['_Whisply RX Pair'] === pair && !pr['Prescription']) pr.For = label; });
      return list;
    }
    function submit(e) {
      e && e.preventDefault(); showErr('');
      if (!variant.available) return;
      var q = getQ(), props = {}, items = [], pairId = null;
      $$('[name^="properties["]', form).forEach(function (i) { if ((i.type !== 'checkbox' && i.type !== 'radio') || i.checked) props[i.name.slice(11, -1)] = i.value; });
      if (rxOn()) {
        var m = rxApi.validate(); if (m) return showErr(m);
        if (laOn()) props['Lens upgrade'] = la.dataset.title;
        var l = rxApi.lines(variant.id, q, props); pairId = l.pair; items = items.concat(lensFor(l.items, l.pair, data.colorIndex >= 0 ? clean(variant.options[data.colorIndex]) : ''));
        if (laOn()) items.push({ id: +la.dataset.id, quantity: q, properties: { For: data.title, '_Whisply RX Pair': pairId, '_Lens upgrade for': 'rx:' + pairId } });
      } else items.push({ id: variant.id, quantity: q, properties: props });
      var title = data.title;
      ups.filter(function (u) { return u.checked; }).forEach(function (u) {
        if (u.hasAttribute('data-warranty')) {
          items.push({ id: +(rxOn() && u.dataset.rxId ? u.dataset.rxId : u.dataset.wpUpsell), quantity: q, properties: { For: title, '_Warranty for': rxOn() ? 'rx:' + pairId : 'v:' + variant.id } });
        } else items.push({ id: +u.dataset.wpUpsell, quantity: 1, properties: { For: title, '_Addon for': rxOn() ? 'rx:' + pairId : 'v:' + variant.id } });
      });
      /* second pair: one more frame (and, with Prescription, pair 1's Rx + its own fee / light-adaptive lines) */
      var p2v = p2Active() ? p2Var() : null, wKeys = [rxOn() ? 'rx:' + pairId : 'v:' + variant.id];
      if (p2v) {
        var p2p = { '_Second pair': '1' };
        if (p2Rx()) {
          if (!rxOn()) { p2Msg && (p2Msg.hidden = false); var rt = $('[data-rx-mode="rx"]', rx); (rt || p2).scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); return showErr('Pair 2 uses the prescription from pair 1. Choose Prescription lenses above and add your Rx.'); }
          if (laOn()) p2p['Lens upgrade'] = la.dataset.title;
          var l2 = rxApi.lines(p2v.id, 1, p2p); items = items.concat(lensFor(l2.items, l2.pair, p2v.name)); wKeys.push('rx:' + l2.pair);
          if (laOn()) items.push({ id: +la.dataset.id, quantity: 1, properties: { For: data.title, '_Whisply RX Pair': l2.pair, '_Lens upgrade for': 'rx:' + l2.pair } });
        } else { items.push({ id: p2v.id, quantity: 1, properties: p2p }); wKeys.push('v:' + p2v.id); }
      }
      /* the cart drawer auto-adds a lifetime warranty per pair unless the pair is on its opt-out list (wn-cart.js WOFF):
         follow the product-page warranty checkbox for both pairs, so an unticked warranty is not added back in the bag */
      var wTick = ups.some(function (u) { return u.checked && u.hasAttribute('data-warranty'); });
      try { var wOff = JSON.parse(localStorage.getItem('whisply_warranty_off') || '[]').filter(function (k) { return wKeys.indexOf(k) < 0; });
        if (!wTick) wOff = wOff.concat(wKeys); localStorage.setItem('whisply_warranty_off', JSON.stringify(wOff.slice(-40))); } catch (er) {}
      addBtn && addBtn.classList.add('is-busy');
      return addItems(items).then(function () {
        if (addBtn && addLabel) { addBtn.classList.add('is-done'); addLabel.textContent = 'Added to bag'; }
        toast(q + ' × ' + title + (data.colorIndex >= 0 ? ' (' + clean(variant.options[data.colorIndex]) + ')' : '') + (p2v ? ' + second pair' + (p2v.name ? ' (' + p2v.name + ')' : '') : '') + ' added');
        setTimeout(function () { addBtn && addBtn.classList.remove('is-done'); refresh(); }, 1800);
      }).catch(function (er) { showErr(er.message); }).then(function () { addBtn && addBtn.classList.remove('is-busy'); });
    }
    form.addEventListener('submit', submit);

    /* sticky bar */
    var sticky = $('[data-wp-sticky]', sec), buy = $('[data-wp-buy]', sec);
    if (sticky && buy && 'IntersectionObserver' in window) {
      var sBtn = $('[data-wp-sticky-add]', sticky);
      /* shows once the main button is off-screen (mobile: also before it, after the photos); hides over the footer */
      var buyOut = false, buyAbove = false, footIn = false, stageEl = $('[data-wp-stage]', sec);
      var mob = matchMedia('(max-width: 749px)');
      function paintSticky() {
        var pastStage = stageEl ? stageEl.getBoundingClientRect().bottom < 60 : true;
        var show = buyOut && !footIn && (buyAbove || (mob.matches && pastStage));
        sticky.classList.toggle('is-show', show); sticky.setAttribute('aria-hidden', String(!show)); sBtn.tabIndex = show ? 0 : -1;
        document.documentElement.classList.toggle('wp-has-sticky', show);
      }
      new IntersectionObserver(function (en) {
        var e = en[0]; buyOut = !e.isIntersecting; buyAbove = e.boundingClientRect.top < 0; paintSticky();
      }).observe(buy);
      var foot = document.querySelector('footer, .wn-footer, [data-wn-footer]');
      if (foot) new IntersectionObserver(function (en) { footIn = en[0].isIntersecting; paintSticky(); }).observe(foot);
      window.addEventListener('scroll', function () { if (buyOut && !buyAbove) paintSticky(); }, { passive: true });
      sBtn.addEventListener('click', function () {
        if (!variant.available) { buy.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); return; }
        if (rxOn()) {
          var m = rxApi.validate();
          if (m) { showErr(m); (rx || buy).scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); return; }
        }
        submit();
      });
    }

    /* share */
    $$('[data-wp-share]', sec).forEach(function (sh) {
      var btn = $('[data-wp-share-open]', sh), menu = $('.lp-share__menu', sh), lbl = btn.innerHTML;
      btn.addEventListener('click', function () {
        var d = { title: sh.dataset.title, text: sh.dataset.text, url: sh.dataset.url };
        if (navigator.share && matchMedia('(hover: none)').matches) { navigator.share(d).catch(function () {}); return; }
        menu.hidden = !menu.hidden; btn.setAttribute('aria-expanded', String(!menu.hidden));
      });
      $('[data-wp-share-copy]', sh).addEventListener('click', function () {
        var done = function () { menu.hidden = true; btn.textContent = 'Link copied'; setTimeout(function () { btn.innerHTML = lbl; }, 1800); };
        if (navigator.clipboard) navigator.clipboard.writeText(sh.dataset.url).then(done, function () { prompt('Copy this link', sh.dataset.url); });
        else { prompt('Copy this link', sh.dataset.url); menu.hidden = true; }
      });
      $$('a', menu).forEach(function (a) { a.addEventListener('click', function () { menu.hidden = true; }); });
      document.addEventListener('click', function (e) { if (!sh.contains(e.target)) { menu.hidden = true; btn.setAttribute('aria-expanded', 'false'); } });
    });

    /* start from ?variant= */
    var qv = new URLSearchParams(location.search).get('variant');
    if (qv && String(variant.id) !== qv) {
      var mv = data.variants.filter(function (x) { return String(x.id) === qv; })[0];
      if (mv) { opts.forEach(function (f, i) { $$('button', f).forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.value === mv.options[i])); }); }); update(mv, true); }
    }
    refresh();
  }

  /* ---------- 3-for-2 quick add (variant sheet when the product has several colours) ---------- */
  var sheet;
  function openSheet(handle, btn) {
    btn.classList.add('is-busy');
    fetch(root + 'products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      btn.classList.remove('is-busy');
      if (!sheet) {
        sheet = document.createElement('div'); sheet.className = 'lp-qb'; sheet.hidden = true;
        sheet.innerHTML = '<div class="lp-qb__panel" role="dialog" aria-modal="true" aria-labelledby="WpQbT" tabindex="-1"><div class="lp-qb__top"><img alt="" data-i><div><b id="WpQbT" data-t></b><span class="lp-qb__p" data-p></span></div><button type="button" class="lp-qb__x" data-x aria-label="Close">×</button></div><fieldset class="lp-opt lp-opt--sw"><legend>Colour: <b data-c></b></legend><div class="lp-opt__vals" data-o></div></fieldset><p class="lp-err" data-e role="alert" hidden></p><button type="button" class="lp-add" data-a>Add to cart</button></div>';
        document.body.appendChild(sheet);
        sheet.addEventListener('click', function (e) { if (e.target === sheet || e.target.closest('[data-x]')) closeSheet(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet && !sheet.hidden) closeSheet(); });
      }
      var vs = p.variants, cur = vs.filter(function (v) { return v.available; })[0] || vs[0];
      var half = Math.round(p.price / 2);
      $('[data-t]', sheet).textContent = p.title;
      $('[data-p]', sheet).innerHTML = '<b>' + fmt(half) + '</b> <s>' + fmt(p.price) + '</s>';
      var o = $('[data-o]', sheet); o.innerHTML = '';
      var pick = function (v) {
        cur = v; $('[data-c]', sheet).textContent = clean(v.title);
        var img = (v.featured_image && v.featured_image.src) || p.featured_image; $('[data-i]', sheet).src = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
        $$('button', o).forEach(function (b) { b.setAttribute('aria-pressed', String(+b.dataset.id === v.id)); });
        var a = $('[data-a]', sheet); a.disabled = !v.available; a.textContent = v.available ? 'Add to cart · ' + fmt(v.price) : 'Sold out';
      };
      vs.forEach(function (v) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'lp-sw' + (v.available ? '' : ' is-out'); b.dataset.id = v.id;
        b.setAttribute('aria-label', clean(v.title)); b.title = clean(v.title);
        var src = v.featured_image && v.featured_image.src;
        b.innerHTML = src ? '<img alt="" loading="lazy" src="' + src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=140">' : '<span class="lp-sw__dot" style="background:#C9CDDA"></span>';
        b.addEventListener('click', function () { pick(v); });
        o.appendChild(b);
      });
      pick(cur);
      $('[data-e]', sheet).hidden = true;
      $('[data-a]', sheet).onclick = function () {
        var a = this; a.classList.add('is-busy');
        addItems([{ id: cur.id, quantity: 1 }]).then(function () { closeSheet(); toast(p.title + ' (' + clean(cur.title) + ') added'); })
          .catch(function (er) { var e = $('[data-e]', sheet); e.textContent = er.message; e.hidden = false; })
          .then(function () { a.classList.remove('is-busy'); });
      };
      sheet._ret = btn; sheet.hidden = false; $('.lp-qb__panel', sheet).focus();
    }).catch(function () { btn.classList.remove('is-busy'); location.href = root + 'products/' + handle; });
  }
  function closeSheet() { if (!sheet) return; sheet.hidden = true; sheet._ret && sheet._ret.focus(); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wp-qb]'); if (!b) return;
    e.preventDefault();
    if (window.WNQuickBuy && typeof window.WNQuickBuy.open === 'function') { window.WNQuickBuy.open(b.dataset.wpQb, b); return; }
    if (b.dataset.multi === '1') return openSheet(b.dataset.wpQb, b);
    b.classList.add('is-busy');
    addItems([{ id: +b.dataset.variant, quantity: 1 }]).then(function () { toast('Added to bag'); })
      .catch(function (er) { toast(er.message); }).then(function () { b.classList.remove('is-busy'); });
  });

  /* reviews: show the rest */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wpx-revs-more]'); if (!b) return;
    var sec = b.closest('[data-lq-revs]'); $$('[data-wpx-more]', sec).forEach(function (a) { a.hidden = false; });
    b.remove();
  });
  document.addEventListener('shopify:block:select', function (e) { if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-wpx-more')) e.target.hidden = false; });

  /* reviews slider under the buy button: swipe on touch, prev/next arrows on desktop */
  function initRevs(box) {
    if (box._lp) return; box._lp = true;
    var rail = box.querySelector('[data-wp-revs-rail]'), btns = $$('[data-wp-revs-step]', box);
    if (!rail) return;
    function paint() {
      var max = rail.scrollWidth - rail.clientWidth;
      btns.forEach(function (b) { b.disabled = +b.dataset.wpRevsStep < 0 ? rail.scrollLeft <= 2 : rail.scrollLeft >= max - 2; });
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var card = rail.querySelector('.lp-rev'), step = card ? card.getBoundingClientRect().width + 8 : rail.clientWidth * 0.8;
        rail.scrollBy({ left: step * +b.dataset.wpRevsStep, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    rail.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault(); var b = btns[e.key === 'ArrowLeft' ? 0 : 1]; b && !b.disabled && b.click();
    });
    rail.addEventListener('scroll', function () { requestAnimationFrame(paint); }, { passive: true });
    window.addEventListener('resize', paint); paint();
  }
  /* theme editor: open the add-ons collapsible when its block is selected */
  document.addEventListener('shopify:block:select', function (e) { var d = e.target && e.target.closest && e.target.closest('details.lp-ups-acc'); if (d) d.open = true; });

  /* related-products rail: 1px line with a blue segment showing scroll position */
  function initRail(rail) {
    if (rail._lp) return; rail._lp = true;
    var bar = rail.parentNode.querySelector('[data-lp-rail-prog]'), seg = bar && $('i', bar);
    if (!seg) return;
    function paint() {
      var max = rail.scrollWidth - rail.clientWidth, vis = rail.clientWidth / Math.max(1, rail.scrollWidth);
      bar.hidden = max <= 2;
      seg.style.width = (vis * 100) + '%';
      seg.style.transform = 'translateX(' + (max > 0 ? (rail.scrollLeft / max) * ((1 - vis) / vis) * 100 : 0) + '%)';
    }
    rail.addEventListener('scroll', function () { requestAnimationFrame(paint); }, { passive: true });
    window.addEventListener('resize', paint); paint();
  }

  function boot(scope) {
    $$('[data-wn-pdp]', scope).forEach(initPdp);
    $$('[data-lp-rail]', scope).forEach(initRail);
    $$('[data-wp-revs]', scope).forEach(initRevs);
    lazyVideos(scope);
  }
  boot(document); tick(); setInterval(tick, 1000);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); tick(); });
})();